<template>
  <div am-img-attrs v-click-outside="() => isOpen = false">
    <p class="_margin-right:1/4">Attributes</p>
    <div class="_display:flex _flex-wrap:wrap _align-items:center">
      <i-badge
        v-for="(attr, index) in attrs"
        :key="attr"
        :am-tag-badge="attr.id % 10"
        class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
        color="primary"
      >
        <p class="_padding-right:1/2 _margin:0">
          {{
            (attr.type[0].toUpperCase() +
            attr.type.slice(1)).replaceAll('_', ' ').replace('type', '') +
            ' : ' + attr.name
          }}
        </p>
        <div class="_display:flex _align-items:center">
          <svg am-icon @click="delAttr(index)" viewBox="0 0 24 24" style="fill: var(----color);">
            <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
          </svg>
        </div>
      </i-badge>
      <svg
        v-if="!loading || !isOpen"
        viewBox="0 0 24 24"
        class="_margin-left:1/4"
        am-icon="color"
        @click="showAttr()"
      >
        <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24" />
        <rect x="0" y="0" width="24" height="24" fill="transparent"></rect>
      </svg>
      <svg
        v-if="loading && isOpen"
        viewBox="0 0 24 24"
        class="_margin-left:1/4"
        am-icon="color"
        :am-loading="loading"
      >
        <use xlink:href="@/assets/icons.svg#preloader" x="0" y="0" width="24" height="24" />
        <rect x="0" y="0" width="24" height="24" fill="transparent"></rect>
      </svg>
    </div>
    <div v-if="isOpen && !loading" am-add-attr>
      <hr>
      <div am-scroll v-if="types">
        <div
          v-for="item in types"
          :key="item"
        >
          <div
            v-if="filterAttr(item).length"
            class="_padding-top:1/2 _padding-bottom:1/2 _display:flex _flex-wrap:wrap _align-items:center"
          >
            <i-badge
              v-for="attr in filterAttr(item)"
              :key="attr.id"
              :am-tag-badge="attr.id % 10"
              class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
              @click="addAttr(attr)"
            >
              <p>
                {{
                  (attr.type[0].toUpperCase() +
                  attr.type.slice(1)).replaceAll('_', ' ').replace('type', '') +
                  ' : ' + attr.name
                }}
              </p>
            </i-badge>
          </div>
        </div>
      </div>
      <div v-if="!filterAllAttr || !filterAllAttr.length" class="_margin:1/2">
        No results
      </div>
    </div>
</div>
</template>

<script>
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex'
export default {
  props: {
    image: {
      type: Object,
      required: true
    },
    types: {
      type: Array
    },
    data: {
      type: [Object, Boolean],
      default: false
    }
  },
  data: () => ({
    isOpen: false
  }),
  computed: {
    ...mapState('parts', ['openImageModal']),
    ...mapState('attributes', ['loading', 'attributes']),
    ...mapGetters('attributes', [
      'getAllAttributtes'
    ]),
    attrs () {
      return this.image.attrs
    },
    filterAllAttr () {
      const attrs = []
      this.types.forEach(el => {
        if (this.attributes[el]) {
          this.attributes[el].forEach(attr => attrs.push(attr))
        }
      })
      if (attrs.length > 0) {
        return attrs.filter((elem) => !this.attrs?.find(({ id }) => elem.id === id))
      } else return false
    }
  },
  methods: {
    filterAttr (type) {
      if (type && this.attributes[type]) {
        return this.attributes[type].filter((elem) => !this.attrs?.find(({ id }) => elem.id === id)).sort((a, b) => a.code > b.code ? 1 : -1)
      }
      return []
    },
    ...mapMutations('parts', ['SET_CHANGED_IMAGES']),
    ...mapMutations('attributes', [
      'setChangedType'
    ]),
    ...mapActions('attributes', ['getAttributes']),
    showAttr () {
      this.isOpen = true
      this.types.forEach(el => {
        this.setChangedType(el)
        this.getAttributes()
      })
    },
    addAttr (attr) {
      this.attrs.push(attr)
      this.SET_CHANGED_IMAGES({
        subtable: this.$route.params.subtable,
        data: this.image,
        field: 'attrs',
        partInfo: this.data || this.openImageModal.data
      })
    },
    delAttr (index) {
      this.attrs.splice(index, 1)
      this.SET_CHANGED_IMAGES({
        subtable: this.$route.params.subtable,
        data: this.image,
        field: 'attrs',
        partInfo: this.data || this.openImageModal.data
      })
    }
  }
}
</script>

<style lang="scss">
[am-img-attrs] [am-add-attr] {
  [am-scroll] {
    max-height: 13rem;
    overflow-y: scroll;
  }
  .badge[am-tag-badge] p,
  .badge[am-tag-badge] {
    cursor: pointer !important;
  }
}
</style>
